import { operatorFromFilter } from './operator-from-filter';
import { addressVerificationOperatorFromFilter } from './address-verification-operator-from-filter';
import { OPERATOR_TYPE_SHIPPING_MY_ACCOUNT } from '../constants/filter-operator-type';
import { externalShippingAccountOperatorFromFilter } from './external-shipping-account-operator-from-filter';
import {
  EDITOR_TYPE_ADDRESS_VERIFICATION,
  EDITOR_TYPE_SHIPPING_ACCOUNT,
  EDITOR_TYPE_EXTERNAL_SHIPPING_ACCOUNT,
} from '../constants/filter-editor-type';

export const operatorFromAppliedFilter = (editorType, operator, isIn, isNull, value) => {
  if (editorType === EDITOR_TYPE_ADDRESS_VERIFICATION) {
    return addressVerificationOperatorFromFilter(isIn, isNull);
  }
  if (editorType === EDITOR_TYPE_SHIPPING_ACCOUNT) {
    return OPERATOR_TYPE_SHIPPING_MY_ACCOUNT;
  }
  if (editorType === EDITOR_TYPE_EXTERNAL_SHIPPING_ACCOUNT) {
    return externalShippingAccountOperatorFromFilter(value);
  }
  return operatorFromFilter(operator, isIn, isNull, value);
};
